import * as React from 'react';
import { createRoot } from 'react-dom/client';
import root from 'window-or-global';
import { BrowserRouter } from 'react-router-dom';
import './i18n';

import { App } from './App';

const reactDomEle = root.document && root.document.getElementById('bodyWrapper');
if (reactDomEle) {
    createRoot(reactDomEle).render(
        <BrowserRouter>
            <App />
        </BrowserRouter>
    );
}
